var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"le-radiocheckbox"},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('input',{attrs:{"type":"radio","name":_vm.name},domProps:{"checked":_vm.checked? 'checked' : false},on:{"click":_vm.clicked}}),_c('span',{staticClass:"checkmark"})])
}
var staticRenderFns = []

export { render, staticRenderFns }